interface ISectorHTML {
  name: string;
  backgroundColor: string;
  size: number;
  degree: number;
  number: number;
  winSectorNumber: number;
  textColor: string;
}

export const wheelSectorClass = 'wheelSector';
export const wheelSectorTextWrapClass = 'wheelSectorTextWrap';
export const wheelSectorTextClass = 'wheelSectorText';

export const sectorHTML = ({
  name,
  backgroundColor,
  size,
  degree,
  number,
  textColor,
}: ISectorHTML) => {

  const degreeToPercent = (100 * degree) / 360;

  const circleDiameter = size * 2;

  const background = `background: conic-gradient(${backgroundColor} ${degreeToPercent}%, transparent 0);`;

  const transform = `transform: rotate(${degree * (number - 1)}deg);`;

  const wheelSectorStyle = `
    ${background}
    ${transform}
    height: ${circleDiameter}px;
    width: ${circleDiameter}px;
    transition: background-color 1000ms linear;
  `;

  const wheelSectorTextWrapStyle = `
    transform: rotate(-${90 - degree / 2}deg);
  `;

  const wheelSectorTextStyle = `
    color: ${textColor};
  `;

  return `
      <div class='${wheelSectorClass}' style='${wheelSectorStyle}' data-id=${number} data-color=${backgroundColor} data-percent=${degreeToPercent}>
      <div class='${wheelSectorTextWrapClass}' style='${wheelSectorTextWrapStyle}'>
        <div class='${wheelSectorTextClass}' style='${wheelSectorTextStyle}'>${name}</div>
      </div>
    </div>
  `;
};
